export enum SLAStatusEnum {
  SLA = 'sla',
  OVERDUE = 'overdue',
  NO_PROBLEM = 'no-problem',
  SLA_REACHED = 'sla-reached',
}

export type SLAStatusType = 'sla' | 'overdue' | 'no-problem' | 'sla-reached';
